export default __webpack_public_path__ + "static/media/logo_ion_pay.b2052fe1.png";